/* Publish by EComposer at 2026-10-14 13:14:18*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2jltiol4cml"]=  window.__ectimmers["ecom-2jltiol4cml"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2jltiol4cml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2jltiol4cml', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gii3e3ly8pa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gii3e3ly8pa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7stsul5ygfh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7stsul5ygfh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u0k26ard50g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u0k26ard50g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfgs7ar454l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfgs7ar454l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wdb6k6da34').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wdb6k6da34', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kl8bwjhqipd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kl8bwjhqipd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tz109w14nkm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tz109w14nkm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvwbtodkme').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvwbtodkme', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g4gdi9u6alt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g4gdi9u6alt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yh6rz25rmn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yh6rz25rmn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14kqri7b2ur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14kqri7b2ur', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jipk658sidb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jipk658sidb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9t9d7arscr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9t9d7arscr', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uhqlcnn8pwh"]=  window.__ectimmers["ecom-uhqlcnn8pwh"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-uhqlcnn8pwh"]["gaity3mlg"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-uhqlcnn8pwh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uhqlcnn8pwh', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4rj2yghq4hb"]=  window.__ectimmers["ecom-4rj2yghq4hb"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-4rj2yghq4hb"]["pfkmhnisd"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-4rj2yghq4hb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4rj2yghq4hb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}